import styled from 'styled-components';
import {
  FontSizes,
  HeaderSecondary,
  LinkSmall,
} from '../../common/typography/typography.styles';
import { BREAKPOINTS } from '../../constants/breakpoints';

export const PrivacyOptOutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  padding: 2rem 2.4rem;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.body.backgroundColor};
`;

export const PrivacyOptOutButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;

  button {
    width: fit-content;
  }
`;

export const PrivacyOptOutTextContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 2.4rem;
  background-color: ${({ theme }) => theme.colors.namedColors.white};
  border: 1px solid ${({ theme }) => theme.colors.baseColors.grey50};
  border-radius: 2rem;
  padding: 4rem;
  max-width: 84.6rem;

  ${HeaderSecondary} {
    font-size: ${FontSizes.bigPlus};
  }

  p {
    line-height: 2.2rem;
    letter-spacing: 0.5px;
    font-size: ${FontSizes.medium};
    font-weight: 400;
  }

  p:first-of-type {
    font-weight: 600;
  }

  ${LinkSmall} {
    font-size: ${FontSizes.medium};
  }

  @media (max-width: ${BREAKPOINTS.mobile.css}) {
    background-color: ${({ theme }) => theme.colors.body.backgroundColor};
    border: none;
    padding: 0 0 1.6rem 0;

    ${HeaderSecondary} {
      font-size: ${FontSizes.big};
    }
  }
`;
